import React from 'react';

import { clsx } from 'clsx';

import { PictureResponsiveProps } from './types';

const PictureResponsive = ({
  className,
  src,
  alt = '',
  imageClassName,
  sources,
}: PictureResponsiveProps) => {
  return (
    <picture className={className}>
      {sources.map((sourceItem, index) => (
        <source
          key={index.toString()}
          className={clsx(imageClassName, sourceItem.className)}
          {...sourceItem}
        />
      ))}
      <img className={imageClassName} src={src} alt={alt} />
    </picture>
  );
};

export default PictureResponsive;
